module.exports = __webpack_public_path__ + "media/images/flags/CF-46becbda36542f7ca8b0c1664e50143a.svg";